import { SizeXlIcon } from './SizeXlIcon';

/**
 * author: Austin Andrews
 * id E7FCE878-E3CA-4EF8-B0B5-D926ACE33122
 * name size-xl
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/size-xl.svg
 * tags
 */
export const SizeExtraLargeIcon = SizeXlIcon;
export default SizeExtraLargeIcon